<template>
  <v-app>
		<CargaInicial v-if="!$root.accesoInicialCargado"></CargaInicial>
		<Acceso v-else-if="$root.accesoInicialCargado && (!$root.datos || !$root.datos.id)"></Acceso>
		<Inicio v-else-if="$root.accesoInicialCargado && $root.datos && $root.datos.id"></Inicio>
		<div v-else><p>Error: 2398</p></div>
  </v-app>
</template>

<script>
import CargaInicial from '../../cliente-comun/componentes/CargaInicial';
import Acceso from '../../cliente-comun/componentes/Acceso';
import Inicio from './views/Inicio';

export default {
  name: 'App',
  components: {
		CargaInicial,
		Acceso,
		Inicio
  },
};
</script>
